// PreAuthApp.jsx
import React, { useCallback, useMemo } from "react";
import { useIdleTimer } from "react-idle-timer";
import { Switch, useHistory, useLocation, withRouter, RouteComponentProps } from "react-router-dom";
import { NON_AUTHENTICATED_URLS } from "../const/preAuthConsts";
import { navigate } from "../utils/navigationUtils";
import Redirect from "./common/Redirect/Redirect";
import { getNextPath } from "./Pages/PreAuthPages/loginUtils";
import preAuthRoutes from "./routes/preAuthRoutes";
import { renderRoutes } from "./routes/routesUtil";

const LONG_IDLE_TIME = 1000 * 60 * 40;

interface PreAuthAppProps extends RouteComponentProps {
    onLogin: () => void;
}

const PreAuthApp: React.FC<PreAuthAppProps> = ({ onLogin }) => {
    const location = useLocation();
    const history = useHistory();

    const nextUrl = useMemo(() => {
        const currentUrl = location.pathname + location.search + location.hash;
        return NON_AUTHENTICATED_URLS.login.concat("?next=", encodeURIComponent(currentUrl));
    }, [location]);

    const onLongIdle = useCallback(() => {
        if (getNextPath()) navigate(NON_AUTHENTICATED_URLS.login);
    }, [history]);

    useIdleTimer({
        element: document,
        timeout: LONG_IDLE_TIME,
        onIdle: onLongIdle,
    });

    return (
        <>
            <div className="page-content">
                <Switch>
                    {renderRoutes(preAuthRoutes, {
                        appProps: { onLogin },
                    })}
                    <Redirect to={nextUrl} />
                </Switch>
            </div>
        </>
    );
};

export default withRouter(PreAuthApp);
